import { Link, useLocation } from 'react-router-dom';
import { Wallet, ClipboardList } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const TABS = [
  { to: '/cost-ledger', label: 'Cost ledger', icon: Wallet, key: 'ledger' },
  { to: '/client-pos', label: 'Client POs', icon: ClipboardList, key: 'client-pos', adminOnly: true },
];

/** Tab strip shared by the Ledger pages — Client POs lives here now instead of the top nav. */
export function LedgerTabs({ className = '' }) {
  const { isAdmin } = useAuth();
  const { pathname } = useLocation();
  return (
    <div className={`inline-flex items-center gap-1 rounded-lg border border-white/10 bg-[#2A3240] p-1 ${className}`} role="tablist" data-testid="ledger-tabs">
      {TABS.filter((t) => !t.adminOnly || isAdmin).map((t) => {
        const active = pathname === t.to || pathname.startsWith(t.to + '/');
        return (
          <Link
            key={t.key}
            to={t.to}
            role="tab"
            aria-selected={active}
            data-testid={`ledger-tab-${t.key}`}
            className={`inline-flex items-center gap-2 px-3.5 h-9 rounded-md text-sm font-medium transition-colors ${
              active ? 'bg-[#F5A623] text-[#1E2530]' : 'text-gray-300 hover:text-white hover:bg-white/5'
            }`}
          >
            <t.icon className="w-4 h-4" />
            {t.label}
          </Link>
        );
      })}
    </div>
  );
}
